import React from 'react';

const defaultProps = { size: 18, className: '', strokeWidth: 1.75 };

function Svg({ children, size, className, strokeWidth, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
      {...rest}
    >
      {children}
    </svg>
  );
}

export function IconPencil(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
    </Svg>
  );
}

export function IconTrash(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M3 6h18" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <line x1="10" y1="11" x2="10" y2="17" />
      <line x1="14" y1="11" x2="14" y2="17" />
    </Svg>
  );
}

export function IconCheck(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M20 6 9 17l-5-5" />
    </Svg>
  );
}

export function IconX(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </Svg>
  );
}

export function IconFilter(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M22 3H2l7.2 9.04V19l4.8 2.5v-9.46L22 3z" />
    </Svg>
  );
}

export function IconGripVertical(props) {
  const { size = 18, className = '' } = { ...defaultProps, ...props };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      aria-hidden
    >
      <g fill="currentColor">
        <circle cx="9" cy="5" r="1.5" />
        <circle cx="15" cy="5" r="1.5" />
        <circle cx="9" cy="12" r="1.5" />
        <circle cx="15" cy="12" r="1.5" />
        <circle cx="9" cy="19" r="1.5" />
        <circle cx="15" cy="19" r="1.5" />
      </g>
    </svg>
  );
}

export function IconLayoutGrid(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <rect width="7" height="7" x="3" y="3" rx="1" />
      <rect width="7" height="7" x="14" y="3" rx="1" />
      <rect width="7" height="7" x="14" y="14" rx="1" />
      <rect width="7" height="7" x="3" y="14" rx="1" />
    </Svg>
  );
}

export function IconLayers(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <polygon points="12 2 2 7 12 12 22 7 12 2" />
      <polyline points="2 17 12 22 22 17" />
      <polyline points="2 12 12 17 22 12" />
    </Svg>
  );
}

export function IconMapPin(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
      <circle cx="12" cy="10" r="3" />
    </Svg>
  );
}

export function IconUtensils(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M3 2v7c0 1.1 2 2 2 2s2-.9 2-2V2" />
      <path d="M7 2v20" />
      <path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1 2 2 2 2s2-.9 2-2Z" />
    </Svg>
  );
}

export function IconUsers(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </Svg>
  );
}

export function IconUser(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </Svg>
  );
}

export function IconPhone(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </Svg>
  );
}

export function IconShoppingBag(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
      <path d="M3 6h18" />
      <path d="M16 10a4 4 0 0 1-8 0" />
    </Svg>
  );
}

export function IconStar(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </Svg>
  );
}

/** Popular / spicy accent (menu preview cards). */
export function IconFlame(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />
    </Svg>
  );
}

export function IconLeaf(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2a1 1 0 0 1 1 1v6h6a1 1 0 0 1 .82 1.64C23.16 15.13 19.35 19 12 19Z" />
      <path d="M2 21a1 1 0 0 1-1-1v-6a1 1 0 0 1 .64-.94A16 16 0 0 0 12 19Z" />
    </Svg>
  );
}

export function IconMessageSquare(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </Svg>
  );
}

export function IconLifeBuoy(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="4" />
      <path d="m4.93 4.93 4.24 4.24" />
      <path d="m14.83 14.83 4.24 4.24" />
      <path d="m14.83 9.17 4.24-4.24" />
      <path d="m9.17 14.83-4.24 4.24" />
    </Svg>
  );
}

export function IconGift(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <rect x="3" y="8" width="18" height="4" rx="1" />
      <path d="M12 8v13" />
      <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" />
      <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5" />
    </Svg>
  );
}

export function IconShield(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
    </Svg>
  );
}

export function IconFileText(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </Svg>
  );
}

export function IconInbox(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
      <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
    </Svg>
  );
}

export function IconChevronDown(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="m6 9 6 6 6-6" />
    </Svg>
  );
}

export function IconChevronLeft(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <polyline points="16 18 10 12 16 6" fill="none" />
    </Svg>
  );
}

export function IconChevronRight(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <polyline points="8 18 14 12 8 6" fill="none" />
    </Svg>
  );
}

export function IconLogOut(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </Svg>
  );
}

export function IconClock(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </Svg>
  );
}

export function IconTruck(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
      <path d="M15 18H9" />
      <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
      <circle cx="17" cy="18" r="2" />
      <circle cx="7" cy="18" r="2" />
    </Svg>
  );
}

export function IconPackage(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="m7.5 4.27 9 5.15" />
      <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
      <path d="m3.3 7.8 8.7 5 8.7-5" />
      <path d="M12 22V12" />
    </Svg>
  );
}

export function IconHistory(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
      <path d="M3 3v5h5" />
      <path d="M12 7v5l4 2" />
    </Svg>
  );
}

export function IconCreditCard(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <rect width="20" height="14" x="2" y="5" rx="2" />
      <line x1="2" x2="22" y1="10" y2="10" />
    </Svg>
  );
}

export function IconPieChart(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
      <path d="M22 12A10 10 0 0 0 12 2v10z" />
    </Svg>
  );
}

export function IconTrendingUp(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="m22 7-8.5 8.5-5-5L2 17" />
      <path d="M16 7h6v6" />
    </Svg>
  );
}

/** Connected nodes — commission / workflow diagram. */
export function IconWorkflow(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <rect width="8" height="8" x="3" y="3" rx="2" />
      <path d="M7 11v4a2 2 0 0 0 2 2h4" />
      <rect width="8" height="8" x="13" y="13" rx="2" />
    </Svg>
  );
}

export function IconVolume2(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
      <path d="M16 9a5 5 0 0 1 0 6" />
      <path d="M19.364 6.636a9 9 0 0 1 0 10.728" />
    </Svg>
  );
}

export function IconVolumeX(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
      <line x1="22" x2="16" y1="9" y2="15" />
      <line x1="16" x2="22" y1="9" y2="15" />
    </Svg>
  );
}

/** Speaker body (matches common mute-icon shape). */
function speakerBodyPaths() {
  return <path d="M10.5 4.75 6.25 8.25H3.25v7.5h3L10.5 19.25V4.75z" />;
}

/** Alerts on — speaker with sound waves. */
export function IconSpeakerOn(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      {speakerBodyPaths()}
      <path d="M13.75 9a4.25 4.25 0 0 1 0 6" />
      <path d="M16.5 6.25a7.75 7.75 0 0 1 0 11.5" />
    </Svg>
  );
}

/** Muted / silent — speaker with diagonal slash (like standard mute icon). */
export function IconSpeakerMute(props) {
  const p = { ...defaultProps, strokeWidth: 2.25, ...props };
  return (
    <Svg {...p}>
      {speakerBodyPaths()}
      <line x1="2.75" y1="2.75" x2="21.25" y2="21.25" />
    </Svg>
  );
}

export function IconImage(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
      <circle cx="9" cy="9" r="2" />
      <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
    </Svg>
  );
}

export function IconEye(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </Svg>
  );
}

export function IconPlus(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </Svg>
  );
}

export function IconCopy(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
      <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
    </Svg>
  );
}

export function IconExternalLink(props) {
  const p = { ...defaultProps, ...props };
  return (
    <Svg {...p}>
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </Svg>
  );
}

